import styled from 'styled-components';

export const ColumnSettingButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  transform: translateY(-60px);
`;
